import { Component, OnInit } from '@angular/core';
import { FAQList } from '../../utils/constants.helper';

@Component({
  selector: 'app-help-faq-content',
  templateUrl: './help-faq-content.component.html',
  styleUrls: ['./help-faq-content.component.scss'],
})
export class HelpFaqContentComponent {
  faqSelection: any = FAQList;

  section: string = 'all';

  constructor() {}

  showSection(section: any) {
    this.section = section;
  }
}
